import { gql } from "@apollo/client";

export const GET_USER_FAVORITE_REPORTS = gql`
  query GetUserFavoriteReportsByUmdId($umdId: String!) {
    getUserFavoriteReportsByUmdId(umdId: $umdId) {
      umdId
      reportId
      reportName
      reportUrl
    	reportDescription
    }
  }
`;

export const GET_USER_SDWIS_REPORTS = gql`
  query GetUserSdwisReportsByUmdId($umdId: String!) {
    getUserSdwisReportsByUmdId(umdId: $umdId) {
      umdId
      tables {
        reportId
        reportName
      }
    }
  }
`;

export const ADD_FAVORITE_REPORT = gql`
  mutation AddUserFavoriteReport($umdId: String!, $reportId: Int!) {
    addUserFavoriteReport(AddUserFavoriteReport: { umdId: $umdId, reportId: $reportId}) {
      umdId
      reportName
      reportUrl
      reportDescription
    }
  }
`;

export const DELETE_FAVORITE_REPORT = gql`
  mutation DeleteUserFavoriteReport($umdId: String!, $reportId: Int!) {
    deleteUserFavoriteReport(DeleteUserFavoriteReport: { umdId: $umdId, reportId: $reportId}) {
      umdId
      reportName
      reportUrl
      reportDescription
    }
  }
`;